// extracted by mini-css-extract-plugin
export default {"container":"ResourceList_container__o611z","headerContainer":"ResourceList_headerContainer__Wx3nk"};